import CModal from "./modal";
export default CModal;
export type CModalInstance = InstanceType<typeof CModal>;
